import { EmptyArray } from "../domain/empty/model";
import { InsightsRepositoryImplementation } from '../infrastructure/insights-repository-implementation';


import { cacheManager } from '../infrastructure/cache-manager';
const repo = new InsightsRepositoryImplementation();

const CACHE_PREFIX = 'insights';

async function getInsights(uid: string, cid: string | null, insight: string, period: string) {
    try {
        const cacheKey = `${CACHE_PREFIX}-${uid}-${cid}-${insight}-${period}`;

        const cached = cacheManager.getItem(cacheKey);
        if (cached) {
            console.log(`Returning insights for ${uid}/${cid}/${insight}/${period} from cache`);
            return cached;
        }

        const response = await repo.getInsights(uid, cid, insight, period).toPromise();
        const data = response;
        if (!data || (Array.isArray(data) && data.length === 0)) return EmptyArray;

        cacheManager.setItem(cacheKey, data);
        return data;
    } catch (error) {
        console.log(error);
    }
}

export { getInsights }
